export default __webpack_public_path__ + "static/media/minus.798c12c2.svg";